<template>
  <div class="language-switcher">
    <van-dropdown-menu>
      <van-dropdown-item v-model="currentLang" :options="langOptions" @change="onLangChange" />
    </van-dropdown-menu>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant'

export default {
  name: 'LanguageSwitcher',
  components: {
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem
  },
  data() {
    return {
      currentLang: 'zh',
      langOptions: [
        { text: '简体中文', value: 'zh' },
        { text: 'English', value: 'en' }
      ]
    }
  },
  mounted() {
    this.currentLang = this.$i18n.locale
  },
  methods: {
    onLangChange(value) {
      console.log('Language changed to:', value)
      console.log('Before change - i18n locale:', this.$i18n.locale)
      this.$i18n.locale = value
      console.log('After change - i18n locale:', this.$i18n.locale)
      localStorage.setItem('locale', value)
      // 强制重新渲染
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSwitcher.vue